<template>
  <div>
    <div>
      <div class="row question-bank-row">
        <div class="col-sm-12 col-lg-7 col-xl-8 create-question-scroll">
          <div class="heading">
            <h3 class="text-secondary text-left">Question Bank</h3>
          </div>
          <b-card>
            <div class="form-group">
              <div class="row">
                <div class="col-sm-12">
                  <div class="table-responsive">
                    <input
                      type="text"
                      placeholder="Search ..."
                      v-model="searchQuery"
                      class="search_button form-control"
                    />
                    <table id="example" class="table table-hover">
                      <tr>
                        <th>Sr#</th>
                        <th>Title</th>
                        <th>Type</th>
                        <th>Category</th>
                        <th>Themetic Area</th>
                        <th>Level</th>
                        <th>Action</th>
                      </tr>
                      <tr  v-for="(item, index) in filterData "  v-bind:key="item[0].qid" >
                        <template  v-if="item[0].qis_standard != 'standard' && item[0].qstandardType !='pre' && item[0].qstandardType != 'post' &&  userRole != 'Admin' && userRole != 'Advisor'"> 
                        <td >{{index+1}}</td>
                        <td class="text-capitalize">
                          <p class="mb-3">{{item[0].qtitle}}</p>
                          <template v-if="item[0].qtype != 'descriptive'">
                            <ul
                              class="options-ul"
                              v-for="(option, index2) in item[1]"
                              v-bind:key="index2"
                            >
                              <li class="text-capitalize">
                                <span v-if="option.opstatus == 1" style="color: green">
                                  <b>{{index2+1}} : {{ option.otitle }}</b>
                                </span>
                                <span v-if="option.opstatus == 0">{{index2+1}} : {{ option.otitle }}</span>
                                <span v-if="item[0].qcategory == 1" class="text-capitalize"></span>
                              </li>
                            </ul>
                          </template>
                        </td>

                        <td v-if="item[0].qtype == 'checkbox'">
                          MCQ's
                          <code v-if="item[0].qsurveyType == true">(Survey)</code>
                        </td>
                        <td v-if="item[0].qtype == 'descriptive'">
                          DESCRIPTIVE
                          <code v-if="item[0].qsurveyType == true">(Survey)</code>
                        </td>
                        <td v-else>
                          <code>N/A</code>
                        </td>
                        <td v-if="item[0].qcategory == 1">Assessment</td>
                        <td v-else-if="item[0].qcategory == 2">Trainer's Feedback</td>
                        <td v-else-if="item[0].qcategory == 3">Trainee's Feedback</td>
                        <td v-else>
                          <code>N/A</code>
                        </td>
                        <td
                          class="text-capitalize"
                          v-if="item[0].qthemetic_area.length > 0"
                        >{{item[0].qthemetic_area}}</td>
                        <td v-else>
                          <code>N/A</code>
                        </td>
                        <td v-if="item[0].qlevel == 6">Basic</td>
                        <td v-else-if="item[0].qlevel == 7">Intermediate</td>
                        <td v-else-if="item[0].qlevel == 8">Advance</td>
                        <td v-else>
                          <code>N/A</code>
                        </td>
                        <td>
                          <a @click="editQuestion(item)">
                            <vs-icon
                              class="mr-0"
                              icon="edit"
                              style="color:#007bff;font-size:18px !important;font-weight:600;cursor: pointer;"
                            ></vs-icon>
                          </a>
                          <a @click="deleteQuestion(item[0].qid)">
                            <vs-icon
                              class="mr-0"
                              icon="delete"
                              style="color:#ff0000c7;font-size:18px !important;font-weight:600;cursor: pointer;"
                            ></vs-icon>
                          </a>
                        </td>
                        </template>
                        <template v-else-if="userRole !='Program Officer' && userRole != 'Trainer'">
                           <td >{{index+1}}</td>
                        <td class="text-capitalize">
                          <p class="mb-3">{{item[0].qtitle}}</p>
                          <template v-if="item[0].qtype != 'descriptive'">
                            <ul
                              class="options-ul"
                              v-for="(option, index2) in item[1]"
                              v-bind:key="index2"
                            >
                              <li class="text-capitalize">
                                <span v-if="option.opstatus == 1" style="color: green">
                                  <b>{{index2+1}} : {{ option.otitle }}</b>
                                </span>
                                <span v-if="option.opstatus == 0">{{index2+1}} : {{ option.otitle }}</span>
                                <span v-if="item[0].qcategory == 1" class="text-capitalize"></span>
                              </li>
                            </ul>
                          </template>
                        </td>

                        <td v-if="item[0].qtype == 'checkbox'">
                          MCQ's
                          <span v-if="item[0].qis_standard == 'standard'">
                            <code v-if="item[0].qstandardType == 'pre'">(Standard, Pre Assessment)</code>
                            <code v-if="item[0].qstandardType == 'post'">(Standard, Post Assessment)</code>
                          </span>
                          <code v-if="item[0].qsurveyType == true">(Survey)</code>
                        </td>
                        <td v-if="item[0].qtype == 'descriptive'">
                          DESCRIPTIVE
                          <code v-if="item[0].qsurveyType == true">(Survey)</code>
                        </td>
                        <td v-else>
                          <code>N/A</code>
                        </td>
                        <td v-if="item[0].qcategory == 1">Assessment</td>
                        <td v-else-if="item[0].qcategory == 2">Trainer's Feedback</td>
                        <td v-else-if="item[0].qcategory == 3">Trainee's Feedback</td>
                        <td v-else>
                          <code>N/A</code>
                        </td>
                        <td
                          class="text-capitalize"
                          v-if="item[0].qthemetic_area.length > 0"
                        >{{item[0].qthemetic_area}}</td>
                        <td v-else>
                          <code>N/A</code>
                        </td>
                        <td v-if="item[0].qlevel == 6">Basic</td>
                        <td v-else-if="item[0].qlevel == 7">Intermediate</td>
                        <td v-else-if="item[0].qlevel == 8">Advance</td>
                        <td v-else>
                          <code>N/A</code>
                        </td>
                        <td>
                          <a @click="editQuestion(item)">
                            <vs-icon
                              class="mr-0"
                              icon="edit"
                              style="color:#007bff;font-size:18px !important;font-weight:600;cursor: pointer;"
                            ></vs-icon>
                          </a>
                          <a @click="deleteQuestion(item[0].qid)">
                            <vs-icon
                              class="mr-0"
                              icon="delete"
                              style="color:#ff0000c7;font-size:18px !important;font-weight:600;cursor: pointer;"
                            ></vs-icon>
                          </a>
                        </td>
                          </template>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
        <div
          class="col-sm-12 col-lg-5 col-xl-4 order-first order-lg-2 show-question-scroll create-right"
        >
          <form v-if="!isEdit" @submit.prevent="createQuestionBank">
            <div class="form-group text-dark mt-4">
              <h6>Create New Question</h6>
              <div class="col-sm-12">
                <label class="font-weight-bold">
                  Category
                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                </label>
                <selectize class v-model="select9" :settings="categorySetting" :searchable="true">
                  <option
                    v-for="(item,index) in categorytitleArr"
                    :key="index"
                    :value="item.value"
                  >{{item.text}}</option>
                </selectize>
              </div>
              <div class="col-sm-12" v-if="select9 == 1">
                <label class="font-weight-bold">
                  Thematic Area
                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                </label>
                <selectize
                  id="select-state"
                  v-model="thematicAreaSelected"
                  :settings="thematicAreaSettings"
                >
                  <option
                    v-for="(item,index) in thematicAreasLoad"
                    :key="index"
                    :value="item.id"
                  >{{item.name}}</option>
                </selectize>
              </div>
              <div class="col-sm-12" v-if="select9 == 1">
                <label class="font-weight-bold">Question Level</label>
                <selectize
                  class
                  id="select-state"
                  v-model="level"
                  :settings="levelSetting"
                  :searchable="true"
                >
                  <option
                    v-for="(item,index) in leveltitleArr"
                    :key="index"
                    :value="item.value"
                  >{{item.text}}</option>
                </selectize>
              </div>
            </div>
            <div class="form-group text-dark">
              <!-- <h6 class="sub-frm-title">Question Bank Information</h6> -->

              <template v-if="radiostype == 'descriptive'">
                <div class="col-sm-12">
                  <div class="col-sm-4" style="display:inline-flex;">
                    <label style="margin-right:10px;">
                      <b>Type:</b>
                    </label>
                    <div class="form-check">
                      <vs-radio v-model="radiostype" vs-name="type" vs-value="checkbox">MCQS</vs-radio>
                    </div>

                    <div v-if="select9 == 2 | select9 == 4" class="form-check">
                      <vs-radio
                        v-model="radiostype"
                        vs-name="type"
                        vs-value="descriptive"
                      >Descriptive</vs-radio>
                    </div>
                  </div>
                  <div class="pt-2">
                    <label class="font-weight-bold">Question statement</label>
                    <b-form-textarea id="textarea-rows" v-model="commonQuestion" rows="4"></b-form-textarea>
                    <!-- <input type="text" class="form-control" placeholder="Write question here..." /> -->
                  </div>
                </div>
                <div class="d-flex justify-content-end mt-3 mr-1" style="width: 100%;">
                  <button type="submit" class="btn btn-primary btn-sm">Save</button>
                </div>
              </template>
              <template v-else>
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group row">
                        <label class="col-sm-2">
                          <b>Type:</b>
                        </label>
                        <div class="form-check col-xs-12 col-sm-4 col-md-3 col-lg-3">
                          <vs-radio v-model="radiostype" vs-name="type" vs-value="checkbox">MCQS</vs-radio>
                        </div>
                        <div class="col-xs-12 col-sm-10 col-md-8 col-lg-5" v-if="select9 == 1">
                          <template v-if=" userRole!='Program Officer' && userRole !='Trainer'">
                          <vs-checkbox

                            style="justify-content: left !important;"
                            v-model="isStandard"
                            vs-name="type"
                            vs-value="standard"
                          >Standard</vs-checkbox>
                          </template>
                          <div
                            class="form-check"
                            style="padding: 6px !important;"
                            v-if="isStandard"
                          >
                            <vs-radio
                              v-model="assessmentType"
                              vs-name="standardType"
                              vs-value="pre"
                            >Pre</vs-radio>
                            <vs-radio
                              v-model="assessmentType"
                              vs-name="standardType"
                              vs-value="post"
                            >Post</vs-radio>
                          </div>
                        </div>
                        <div
                          v-if="select9 == 2 | select9 == 4"
                          class="form-check col-xs-12 col-sm-12 col-md-8 col-lg-5"
                        >
                          <vs-radio
                            v-model="radiostype"
                            vs-name="type"
                            vs-value="descriptive"
                          >Descriptive</vs-radio>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <div v-if="radiostype == 'checkbox'" class="form-group row">
                        <label class="col-sm-1">
                          <b>No:</b>
                        </label>
                        <div class="form-check ml-3">
                          <vs-radio
                            v-model="numbertype"
                            vs-name="numbering"
                            vs-value="alphabetLimit"
                          >A-B</vs-radio>
                        </div>
                        <div class="form-check">
                          <vs-radio
                            v-model="numbertype"
                            vs-name="numbering"
                            vs-value="alphabetLimit1"
                          >A-C</vs-radio>
                        </div>
                        <div class="form-check">
                          <vs-radio
                            v-model="numbertype"
                            vs-name="numbering"
                            vs-value="alphabetLimit2"
                          >A-D</vs-radio>
                        </div>
                        <div class="form-check">
                          <vs-radio v-model="numbertype" vs-name="numbering" vs-value="alphabet">A-E</vs-radio>
                        </div>
                        <div class="form-check">
                          <vs-radio
                            v-model="numbertype"
                            vs-name="numbering"
                            vs-value="numberLimit"
                          >1-2</vs-radio>
                        </div>
                        <div class="form-check">
                          <vs-radio
                            v-model="numbertype"
                            vs-name="numbering"
                            vs-value="numberLimit1"
                          >1-3</vs-radio>
                        </div>
                        <div class="form-check">
                          <vs-radio
                            v-model="numbertype"
                            vs-name="numbering"
                            vs-value="numberLimit2"
                          >1-4</vs-radio>
                        </div>
                        <div class="form-check">
                          <vs-radio v-model="numbertype" vs-name="numbering" vs-value="number">1-5</vs-radio>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- new code for add questions starts(with text box alphabet) -->
                <template v-if="radiostype == 'checkbox'">
                  <div class="col-sm-12">
                    <div class="pt-2">
                      <label class="font-weight-bold">Question statement</label>
                      <b-form-textarea id="textarea-rows" v-model="commonQuestion" rows="4"></b-form-textarea>
                      <!-- <input
                        type="text"
                        v-model="commonQuestion"
                        class="form-control"
                        placeholder="Write question here..."
                      />-->
                    </div>
                  </div>

                  <!-- A-B options starts -->
                  <div class="d-flex" style="padding: 4px 16px 0px 16px;">
                    <label class="font-weight-bold w-100 text-left">Options</label>
                    <label class="font-weight-bold w-100 text-right">Correct</label>
                  </div>
                  <template v-if="numbertype == 'alphabetLimit'">
                    <div class="col-sm-12">
                      <!-- option 1 starts -->

                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class="mt-3">
                          <span class="p-2">A</span>
                        </div>
                        <div class="mt-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 1"
                            v-model="qCheckboxArr[0].option1"
                          />
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct1"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 1 ends -->
                      <!-- option 2 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">B</span>
                        </div>
                        <div class="mt-minus-1 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 2"
                            v-model="qCheckboxArr[0].option2"
                          />
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct2"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 2 ends -->

                      <div class="d-flex justify-content-end" style="width: 100%;">
                        <button type="submit" class="btn btn-primary btn-sm">Save</button>
                        <!-- <button type="button" class="btn btn-primary btn-sm">Add New</button> -->
                      </div>
                    </div>
                  </template>

                  <!-- A-B options ends -->
                  <!-- A-C options starts -->
                  <template v-if="numbertype == 'alphabetLimit1'">
                    <div class="col-sm-12">
                      <!-- option 1 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class="mt-3">
                          <span class="p-2">A</span>
                        </div>
                        <div class="mt-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 1"
                            v-model="qCheckboxArr[0].option1"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 1" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct1"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 1 ends -->
                      <!-- option 2 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">B</span>
                        </div>
                        <div class="mt-minus-1 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 2"
                            v-model="qCheckboxArr[0].option2"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 2" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct2"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 2 ends -->
                      <!-- option 3 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">C</span>
                        </div>
                        <div class="mt-minus-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 3"
                            v-model="qCheckboxArr[0].option3"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 3" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct3"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 3 ends -->

                      <div class="d-flex justify-content-end" style="width: 100%;">
                        <button type="submit" class="btn btn-primary btn-sm">Save</button>
                        <!-- <button type="button" class="btn btn-primary btn-sm">Add New</button> -->
                      </div>
                    </div>
                  </template>

                  <!-- A-C options ends -->
                  <!-- A-D options starts -->
                  <template v-if="numbertype == 'alphabetLimit2'">
                    <div class="col-sm-12">
                      <!-- option 1 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class="mt-3">
                          <span class="p-2">A</span>
                        </div>
                        <div class="mt-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 1"
                            v-model="qCheckboxArr[0].option1"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 1" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct1"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 1 ends -->
                      <!-- option 2 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">B</span>
                        </div>
                        <div class="mt-minus-1 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 2"
                            v-model="qCheckboxArr[0].option2"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 2" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct2"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 2 ends -->
                      <!-- option 3 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">C</span>
                        </div>
                        <div class="mt-minus-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 3"
                            v-model="qCheckboxArr[0].option3"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 3" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct3"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 3 ends -->
                      <!-- option 4 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">D</span>
                        </div>
                        <div class="mt-minus-3 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 4"
                            v-model="qCheckboxArr[0].option4"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 4" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct4"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 4 ends -->

                      <div class="d-flex justify-content-end" style="width: 100%;">
                        <button type="submit" class="btn btn-primary btn-sm">Save</button>
                        <!-- <button type="button" class="btn btn-primary btn-sm">Add New</button> -->
                      </div>
                    </div>
                  </template>

                  <!-- A-D options ends -->
                  <!-- A-E options starts -->
                  <template v-if="numbertype == 'alphabet'">
                    <div class="col-sm-12">
                      <!-- option 1 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class="mt-3">
                          <span class="p-2">A</span>
                        </div>
                        <div class="mt-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 1"
                            v-model="qCheckboxArr[0].option1"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 1" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct1"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 1 ends -->
                      <!-- option 2 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">B</span>
                        </div>
                        <div class="mt-minus-1 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 2"
                            v-model="qCheckboxArr[0].option2"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 2" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct2"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 2 ends -->
                      <!-- option 3 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">C</span>
                        </div>
                        <div class="mt-minus-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 3"
                            v-model="qCheckboxArr[0].option3"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 3" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct3"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 3 ends -->
                      <!-- option 4 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">D</span>
                        </div>
                        <div class="mt-minus-3 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 4"
                            v-model="qCheckboxArr[0].option4"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 4" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct4"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 4 ends -->
                      <!-- option 5 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">E</span>
                        </div>
                        <div class="mt-minus-4 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 5"
                            v-model="qCheckboxArr[0].option5"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 5" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct5"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 5 ends -->

                      <div class="d-flex justify-content-end" style="width: 100%;">
                        <button type="submit" class="btn btn-primary btn-sm">Save</button>
                        <!-- <button type="button" class="btn btn-primary btn-sm">Add New</button> -->
                      </div>
                    </div>
                  </template>

                  <!-- 1-4 options Starts -->
                  <template v-if="numbertype == 'numberLimit'">
                    <div class="col-sm-12">
                      <!-- option 1 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class="mt-3">
                          <span class="p-2">1</span>
                        </div>
                        <div class="mt-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 1"
                            v-model="qCheckboxArr[0].option1"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 1" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct1"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 1 ends -->
                      <!-- option 2 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">2</span>
                        </div>
                        <div class="mt-minus-1 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 2"
                            v-model="qCheckboxArr[0].option2"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 2" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct2"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 2 ends -->

                      <div class="d-flex justify-content-end" style="width: 100%;">
                        <button type="submit" class="btn btn-primary btn-sm">Save</button>
                        <!-- <button type="button" class="btn btn-primary btn-sm">Add New</button> -->
                      </div>
                    </div>
                  </template>

                  <!-- 1-3 options Ends -->
                  <!-- 1-3 options Starts -->
                  <template v-if="numbertype == 'numberLimit1'">
                    <div class="col-sm-12">
                      <!-- option 1 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class="mt-3">
                          <span class="p-2">1</span>
                        </div>
                        <div class="mt-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 1"
                            v-model="qCheckboxArr[0].option1"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 1" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct1"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 1 ends -->
                      <!-- option 2 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">2</span>
                        </div>
                        <div class="mt-minus-1 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 2"
                            v-model="qCheckboxArr[0].option2"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 2" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct2"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 2 ends -->
                      <!-- option 3 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">3</span>
                        </div>
                        <div class="mt-minus-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 3"
                            v-model="qCheckboxArr[0].option3"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 3" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct3"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 3 ends -->

                      <div class="d-flex justify-content-end" style="width: 100%;">
                        <button type="submit" class="btn btn-primary btn-sm">Save</button>
                        <!-- <button type="button" class="btn btn-primary btn-sm">Add New</button> -->
                      </div>
                    </div>
                  </template>
                  <!-- 1-3 options Ends -->
                  <!-- 1-4 options Starts -->
                  <template v-if="numbertype == 'numberLimit2'">
                    <div class="col-sm-12">
                      <!-- option 1 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class="mt-3">
                          <span class="p-2">1</span>
                        </div>
                        <div class="mt-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 1"
                            v-model="qCheckboxArr[0].option1"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 1" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct1"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 1 ends -->
                      <!-- option 2 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">2</span>
                        </div>
                        <div class="mt-minus-1 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 2"
                            v-model="qCheckboxArr[0].option2"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 2" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct2"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 2 ends -->
                      <!-- option 3 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">3</span>
                        </div>
                        <div class="mt-minus-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 3"
                            v-model="qCheckboxArr[0].option3"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 3" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct3"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 3 ends -->
                      <!-- option 4 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">4</span>
                        </div>
                        <div class="mt-minus-3 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 4"
                            v-model="qCheckboxArr[0].option4"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 4" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct4"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 4 ends -->

                      <div class="d-flex justify-content-end" style="width: 100%;">
                        <button type="submit" class="btn btn-primary btn-sm">Save</button>
                        <!-- <button type="button" class="btn btn-primary btn-sm">Add New</button> -->
                      </div>
                    </div>
                  </template>

                  <!-- 1-3 options Ends -->
                  <!-- 1-5 options Starts -->
                  <template v-if="numbertype == 'number'">
                    <div class="col-sm-12">
                      <!-- option 1 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class="mt-3">
                          <span class="p-2">1</span>
                        </div>
                        <div class="mt-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 1"
                            v-model="qCheckboxArr[0].option1"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 1" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct1"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 1 ends -->
                      <!-- option 2 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">2</span>
                        </div>
                        <div class="mt-minus-1 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 2"
                            v-model="qCheckboxArr[0].option2"
                          />
                          <!-- <input type="text" class="form-control" placeholder="Option 2" /> -->
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct2"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                        </div>
                      </div>
                      <!-- option 2 ends -->
                      <!-- option 3 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">3</span>
                        </div>
                        <div class="mt-minus-2 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 3"
                            v-model="qCheckboxArr[0].option3"
                          />
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct3"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                          <!-- <input type="text" class="form-control" placeholder="Option 3" /> -->
                        </div>
                      </div>
                      <!-- option 3 ends -->
                      <!-- option 4 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">4</span>
                        </div>
                        <div class="mt-minus-3 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 4"
                            v-model="qCheckboxArr[0].option4"
                          />
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct4"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                          <!-- <input type="text" class="form-control" placeholder="Option 4" /> -->
                        </div>
                      </div>
                      <!-- option 4 ends -->
                      <!-- option 5 starts -->
                      <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                        <div class style="margin-top: -9px;">
                          <span class="p-2">5</span>
                        </div>
                        <div class="mt-minus-4 d-flex" style="width:100%;">
                          <vs-input
                            class="inputx"
                            placeholder="Option 5"
                            v-model="qCheckboxArr[0].option5"
                          />
                          <div v-if="select9 ==1" style="padding: 6px 0px 0px 6px">
                            <vs-radio
                              color="success"
                              v-model="correct5"
                              vs-name="radios1"
                              vs-value="1"
                            ></vs-radio>
                          </div>
                          <!-- <input type="text" class="form-control" placeholder="Option 5" /> -->
                        </div>
                      </div>
                      <!-- option 5 ends -->

                      <div class="d-flex justify-content-end" style="width: 100%;">
                        <button type="submit" class="btn btn-primary btn-sm">Save</button>
                        <!-- <button type="button" class="btn btn-primary btn-sm">Add New</button> -->
                      </div>
                    </div>
                  </template>

                  <!-- 1-5 options Ends -->
                  <!-- A-E options ends -->
                </template>
              </template>
            </div>
          </form>

          <div v-else class="form-group text-dark">
            <h6 style="margin-top: 20px;">Question Bank Information (Update)</h6>
            <div class="col-sm-12">
              <div class="pt-2">
                <b-form-textarea
                  id="textarea-rows"
                  v-model="editQuestionArr.qtitle"
                  placeholder="Descriptive Answer...."
                  rows="4"
                ></b-form-textarea>
                <!-- <input
                  type="text"
                  class="form-control"
                  v-model="editQuestionArr.qtitle"
                  placeholder="Write question here..."
                />-->
              </div>
            </div>

            <!-- A-E options starts -->
            <div class="col-sm-12">
              <!-- option 1 starts -->
              <div v-if="editQuestionArr.qtype == 'checkbox'">
                <div
                  v-for="(option,index) in editOptionArr"
                  :key="index"
                  class="d-flex justify-content-between"
                >
                  <div class="mt-3">
                    <span class="p-2">{{index+1}}</span>
                  </div>
                  <div class="mt-2 d-flex" style="width:100%;">
                    <vs-input class="inputx" placeholder="Option 1" v-model="option.otitle" />
                    <!-- <input type="text" class="form-control" placeholder="Option 1" /> -->
                    <div v-if="editQuestionArr.qcategory == 1" style="padding: 6px 0px 0px 6px">
                      <vs-radio
                        color="success"
                        @change="changeAnswer(option.oid)"
                        v-model="option.opstatus"
                        vs-name="radios1"
                        vs-value="1"
                      ></vs-radio>
                    </div>
                  </div>
                </div>
              </div>
              <!-- option 1 ends -->

              <div class="d-flex justify-content-end mt-2" style="width: 100%;">
                <button
                  type="submit"
                  style="margin-right: 4px"
                  class="btn btn-danger btn-sm"
                  @click="canceEditQuestion()"
                >Cancel</button>
                <button
                  type="submit"
                  class="btn btn-primary btn-sm"
                  @click="updateQuestion()"
                >Update</button>
                <!-- <button type="button" class="btn btn-primary btn-sm">Add New</button> -->
              </div>
            </div>
            <!-- A-E ends  -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Selectize from "vue2-selectize";
import axios from "axios";
export default {
  components: {
    Selectize
  },
  data: () => ({
    questionCount:0,
    editQuestionArr: [],
    thematicAreasLoad: [],
    level: "",
    searchQuery:"",
    commonQuestion: "",
    dAnswer: "",
    descriptiveAnswer: "",
    items: [],

    isSidebar: false,
    radiostype: "checkbox",
    isStandard: "",
    assessmentType: "",
    numbertype: "alphabetLimit",
    qCheckboxArr: [
      {
        question: "",
        option1: "",
        option2: "",
        option3: "",
        option4: "",
        option5: "",
        type: ""
      }
    ],
    qRadioArr: [
      {
        question: "",
        option1: "true",
        option2: "false",
        type: "checkbox"
      }
    ],
    currentQ: 0,
    select1: 1,
    select2: 1,
    select3: 1,
    select4: 1,
    select5: 1,
    select6: 1,
    select7: 1,
    select8: 1,
    value1: "",
    value2: "",
    value3: "",
    value4: "",
    value5: "",
    radios2: "true",
    correct: "",
    correct1: 1,
    correct2: 0,
    correct3: 0,
    correct4: 0,
    correct5: 0,
    qusLimit: "",
    qusType: "",
    qusNo: "",
    questions: [],
    seen: true,
    radios1: "Pre Training Form",
    popupActivo: false,
    activeItem: 0,
    search: "",
    isForm: true,
    isFormData: false,
    selected: "",
    options1: [
      { text: "Correct", value: 1 },
      { text: "Incorrect", value: 0 }
    ],

    thematicAreaSelected: "",
    thematicAreaSettings: {
      maxItems: 3,
      plugins: ["remove_button"],
      placeholder: "Select thematic area here"
    },
    levelSelected: "",
    levelSettings: {
      maxItems: 3,
      plugins: ["remove_button"]
    }, // https://github.com/selectize/selectize.js/blob/master/docs/usage.md
    contact_person: "",
    contact_number: "",
    contact_email: "",
    address: "",
    options: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    textarea: "",
    counterDanger: false,
    currentUser:"",
    userRole: null,
    mydate: "",
    startDate: "",
    endDate: "",
    colorx: "#1db952",
    indexActive: 0,
    trainingCheck: false,
    repeatedCheck: false,
    select1Normal: "",
    select9: 1,
    categorySetting: {
      maxItems: 1,
      searchField: ["text"],
      placeholder: "Select category here"
    },
    categorytitleArr: [
      { text: "Assessment", value: 1 },
      { text: "Trainer's Feedback", value: 2 },
      { text: "Trainee's Feedback", value: 3 },
      { text: "Survey", value: 4 }
    ],
    levelSetting: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select level here"
    },
    leveltitleArr: [
      { text: "Basic", value: 6 },
      { text: "Intermediate", value: 7 },
      { text: "Advance", value: 8 }
    ],
    trueFalseRadio: "",
    yesNoRadio: "",
    isEdit: false
  }),
  mounted() {
     this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if(this.currentUser && this.currentUser.roles){
        this.userRole = this.currentUser.roles.title
    } 
    
    this.allQuestionBank();
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/thematics/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.thematicAreasLoad = response.data;
      });
  },
  watch: {
    numbertype() {
      this.correct1 = 1;
      this.correct2 = 0;
      this.correct3 = 0;
      this.correct4 = 0;
      this.correct5 = 0;
    },
    radiostype() {
      this.commonQuestion = "";
      this.qCheckboxArr[0].option1 = "";
      this.qCheckboxArr[0].option2 = "";
      this.qCheckboxArr[0].option3 = "";
      this.qCheckboxArr[0].option4 = "";
      this.qCheckboxArr[0].option5 = "";
      this.qCheckboxArr[0].correct = "";
    },
    correct1() {
      this.correct2 = 0;
      this.correct3 = 0;
      this.correct4 = 0;
      this.correct5 = 0;
    },
    correct2() {
      this.correct1 = 0;
      this.correct3 = 0;
      this.correct4 = 0;
      this.correct5 = 0;
    },
    correct3() {
      this.correct2 = 0;
      this.correct1 = 0;
      this.correct4 = 0;
      this.correct5 = 0;
    },
    correct4() {
      this.correct2 = 0;
      this.correct3 = 0;
      this.correct1 = 0;
      this.correct5 = 0;
    },
    correct5() {
      this.correct2 = 0;
      this.correct3 = 0;
      this.correct4 = 0;
      this.correct1 = 0;
    },
    select9(val) {
      this.correct1 = 1;
      this.correct2 = 0;
      this.correct3 = 0;
      this.correct4 = 0;
      this.correct5 = 0;
      this.commonQuestion = "";
      this.qCheckboxArr[0].option1 = "";
      this.qCheckboxArr[0].option2 = "";
      this.qCheckboxArr[0].option3 = "";
      this.qCheckboxArr[0].option4 = "";
      this.qCheckboxArr[0].option5 = "";
      this.qCheckboxArr[0].correct = "";
      this.thematicAreaSelected = "";
      this.level = "";
      if (val != 2) {
        this.radiostype = "checkbox";
      }
    }
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    changeAnswer(val) {
      this.editOptionArr.map(item => {
        if (item.oid == val) {
          item.opstatus = 1;
        } else {
          item.opstatus = 0;
        }
      });
    },
    allQuestionBank: function allQuestionBank() {
      let userId = JSON.parse(localStorage.getItem("currentUser"));
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/question-bank/" +
            userId.id +
            "/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.items = response.data;
        });
    },

    createQuestionBank(e) {
      e.preventDefault();
      // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
      let self = this;
      let standard = "";
      let standardTypeNow = "";
      if (this.isStandard) {
        standard = this.isStandard;
        standardTypeNow = this.assessmentType;
      }

      this.inValid = [];
      if (!this.select9) {
        this.inValid.push("Select Category please.");
      }
      if (!this.thematicAreaSelected && this.select9 == 1) {
        this.inValid.push("Select Thematic Area please.");
      }
      if (!this.level && this.select9 == 1) {
        this.inValid.push("Select Question Level please.");
      }
      if (!this.commonQuestion) {
        this.inValid.push("Question statement is required.");
      }
      if (!this.qCheckboxArr[0].option1 && this.radiostype == "checkbox") {
        this.inValid.push("Option number 1 is required.");
      }
      if (!this.qCheckboxArr[0].option2 && this.radiostype == "checkbox") {
        this.inValid.push("Option number 2 is required.");
      }

      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(
            localStorage.getItem("BASE_PATH") +
              "/program-officer/questionbank/create",
            {
              user_id: JSON.parse(localStorage.getItem("currentUser")).id,
              category: this.select9,
              thematicArea: this.thematicAreaSelected,
              level: this.level,
              question: this.commonQuestion,
              descriptiveAnswer: this.dAnswer,
              optionNo: this.numbertype,
              questionType: this.radiostype,
              option1: this.qCheckboxArr[0].option1,
              correct1: this.correct1,

              option2: this.qCheckboxArr[0].option2,
              correct2: this.correct2,

              option3: this.qCheckboxArr[0].option3,
              correct3: this.correct3,

              option4: this.qCheckboxArr[0].option4,
              correct4: this.correct4,

              option5: this.qCheckboxArr[0].option5,
              correct5: this.correct5,

              // correct: this.qCheckboxArr[0].correct,
              trueFalseRadio: this.trueFalseRadio,
              yesNoRadio: this.yesNoRadio,
              standard: standard,
              standardTypeNow: standardTypeNow
            },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            if (response.data.success) {
              self.$toasted.global.successMsg("Record has been added successfully!");
              self.resetForm();
              self.allQuestionBank();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.$toasted.global.errorMsg(error);
          });
      }
    },
    editQuestion(val) {
      this.isEdit = true;
      this.editQuestionArr = val[0];
      this.editOptionArr = val[1];
    },
    canceEditQuestion() {
      this.isEdit = false;
    },
    deleteQuestion(id) {
      let self = this;
      axios
        .post(localStorage.getItem("BASE_PATH") + "/question-bank/delete", {
          questionId: id
        },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if (response.data.success) {
            this.isEdit = false;
            self.$toasted.global.successMsg("Question has been deleted successfully!");
            this.allQuestionBank();
          }
        });
    },
    updateQuestion() {
      let self = this;
      this.openLoading();
      axios
        .post(localStorage.getItem("BASE_PATH") + "/question-bank/update", {
          question: this.editQuestionArr.qtitle,
          questionId: this.editQuestionArr.qid,
          options: this.editOptionArr
        },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success) {
            this.isEdit = false;
            self.$toasted.global.successMsg("Question has been updated successfully!");
            this.allQuestionBank();
          }
        });
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    resetForm() {
      this.category = "";
      this.thematicAreaSelected = "";
      this.level = "";
      (this.isStandard = ""), (this.assessmentType = ""), (this.dAnswer = "");
      this.commonQuestion = "";
      this.qCheckboxArr[0].option1 = "";
      this.qCheckboxArr[0].option2 = "";
      this.qCheckboxArr[0].option3 = "";
      this.qCheckboxArr[0].option4 = "";
      this.qCheckboxArr[0].option5 = "";
      // this.qCheckboxArr[0].correct = '';
      this.trueFalseRadio = "";
      this.yesNoRadio = "";
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Files have been Uploaded."
      });
    }
  },
  computed: {
    filterData: function() {
      return this.items.filter(items => {
        for (var item in items) {
          if (String(items[item].qtitle).toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1) {
            
            return true;
          }
        }
        return false;
      });
    }
  }
};
</script>
<style>
.create-right {
  background: #f7f7f7;
}
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.material-icons {
  font-size: 16px;
}

.f-500 {
  font-weight: 500;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: #007bff !important;
  background-color: #007bff !important;
  float: right;
  margin: 10px 0px;
}

.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}
.options-ul {
  margin-bottom: 2px !important;
}
/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}
@media only screen and (max-width: 992px) {
  .question-bank-row {
    height: 92vh;
    overflow: scroll !important;
  }
  .create-question-scroll {
    height: initial !important;
    overflow: hidden !important;
  }
  .show-question-scroll {
    height: initial !important;
    overflow: hidden !important;
  }
}
.question-bank-row {
  height: 92vh;
  overflow: hidden;
}
.create-question-scroll {
  height: 100vh;
  overflow: auto;
}
.show-question-scroll {
  height: 92vh;
  overflow: auto;
}
.text-secondary {
  padding-left: 16px;
}
.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #f9f9f9;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* Floating label css ends */

.vs-popup--background {
  opacity: 0.3 !important;
}
.con-img-upload .img-upload {
  width: 150px !important;
}
.vs-con-input {
  margin-bottom: 8px !important;
}
.mt-minus-1 {
  margin-top: -18px;
}
.mt-minus-2 {
  margin-top: -18px;
}
.mt-minus-3 {
  margin-top: -17px;
}
.mt-minus-4 {
  margin-top: -1 7px;
}
.mt-minus-5 {
  margin-top: -2px;
}
.mt-minus-6 {
  margin-top: -2 8px;
}
.mt-minus-7 {
  margin-top: -28px;
}
.mt-minus-8 {
  margin-top: -28px;
}
.mt-minus-9 {
  margin-top: -28px;
}
.mt-minus-10 {
  margin-top: -27px;
}
.mt-minus-11 {
  margin-top: -15px;
}
.selectExample {
  margin: 10px 0px 10px 5px !important;
}
.con-select {
  width: 85px !important;
}
</style>